/* eslint-disable-next-line */
/* global IS_PRODUCTION */

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import defaultMessages from '@/lang/en'
// import messages from '@/lang/de'
import axios from '@/js/helper/axios-helper.js'

import { getDateTimeFormats } from './datetime-formats'
import { getNumberFormats } from './number-formats'
import { getLocale } from './localeTranslate'

export const defaultLocale = 'en'
export const mappedDefaultLocale = getLocale(defaultLocale)

// our default language that is preloaded
// const htmlLocale = document.documentElement.lang || defaultLocale
// const loadedLanguage = locales.includes(htmlLocale) ? htmlLocale : defaultLocale

export const getI18n = async store => {
  Vue.use(VueI18n)
  const locales = store.getters['app/LANGUAGES'] // ['en', 'de', 'es', 'nl', 'fr']

  const currentLocaleObject = locales.find(lang => lang.current)
  const currentLocale = currentLocaleObject ? currentLocaleObject.code : defaultLocale
  const mappedCurrentLocale = getLocale(currentLocale)

  const isDefaultLocale = mappedCurrentLocale === mappedDefaultLocale

  axios.defaults.headers.common['Accept-Language'] = mappedCurrentLocale
  document.querySelector('html').setAttribute('lang', mappedCurrentLocale)

  const languages =
    mappedCurrentLocale === mappedDefaultLocale
      ? [mappedCurrentLocale]
      : [mappedCurrentLocale, mappedDefaultLocale]

  const messages = {
    [mappedDefaultLocale]: defaultMessages,
  }

  if (!isDefaultLocale) {
    messages[mappedCurrentLocale] = (
      await import(/* webpackChunkName: "lang-[request]" */ `@/lang/${currentLocale}.js`)
    ).default
  }

  // console.log({
  //   currentLocale,
  //   mappedCurrentLocale,
  //   languages,
  //   messages,
  //   numberFormats: getNumberFormats(languages),
  //   dateTimeFormats: getDateTimeFormats(languages),
  // })

  const i18n = new VueI18n({
    locale: mappedCurrentLocale,
    fallbackLocale: mappedDefaultLocale,
    messages,
    numberFormats: getNumberFormats(languages),
    dateTimeFormats: getDateTimeFormats(languages),
    silentTranslationWarn: true, // IS_PRODUCTION,
    silentFallbackWarn: true, // IS_PRODUCTION,
  })

  store.$i18n = i18n

  const setI18nLanguage = mappedLang => {
    i18n.locale = mappedLang
    axios.defaults.headers.common['Accept-Language'] = mappedLang
    document.querySelector('html').setAttribute('lang', mappedLang)
    return mappedLang
  }

  // if (htmlLocale !== getLocale(loadedLanguage)) {
  //   setI18nLanguage(getLocale(loadedLanguage))
  // }

  const loadLanguageAsync = lang => {
    const mappedLang = getLocale(lang)

    // If the same language
    if (i18n.locale === mappedLang) {
      return Promise.resolve(setI18nLanguage(mappedLang))
    }

    // If the language was already loaded
    if (languages.includes(mappedLang)) {
      return Promise.resolve(setI18nLanguage(mappedLang))
    }

    // If the language hasn't been loaded yet
    return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}.js`).then(messages => {
      i18n.setLocaleMessage(mappedLang, messages.default)
      languages.push(mappedLang)
      return setI18nLanguage(mappedLang)
    })
  }

  return {
    i18n,
    loadLanguageAsync,
  }
}
